module.exports = __webpack_public_path__ + "static/media/chat04.7f27d168.svg";